import { ResultStatus } from '@dispatch/shared/types';
import { Stack, Typography } from '@mui/material';
import { CSSProperties } from 'react';
import { ReactComponent as UsersImage } from './images/users.svg';

type EmptyVariant = 'default' | 'user';
export type EmptyProps = {
  entityName: string;
  status?: ResultStatus;
  variant?: EmptyVariant;
};

const svgStyles: CSSProperties = {
  maxWidth: '20em',
  maxHeight: '20em',
  position: 'absolute',
};

export function EmptyBulkResourceForm() {
  function EmptyState() {
    return (
      <Stack
        direction="column"
        spacing={2}
        alignItems="center"
        p={5}
        mb={2}
        data-testid="empty-container"
      >
        <Typography
          variant="h5"
          color="primary"
          textAlign={'center'}
          data-testid="table-empty-text"
        >
          Please provide data values to proceed with the bulk update.
        </Typography>
        <UsersImage style={svgStyles} data-testid="table-empty-image-user" />
      </Stack>
    );
  }

  return <EmptyState />;
}
